import React from 'react';
import { Flex } from 'reflexbox';

import { SHORT_DAYS_MAP, DAYS } from '../constants';

import { SettingsLabel } from '../components/BranchComponents';
import { DeliveryCheckbox } from './DeliveryComponents';

const DeliveryDaysList = ({ deliveryDays, onChange, disabled }) => {
  const createDayChangeHandler = (day) => (checked) => onChange(day, checked);

  return (
    <>
      <SettingsLabel>Delivery days</SettingsLabel>
      <Flex>
        {DAYS.map(day => (
          <DeliveryCheckbox
            disabled={disabled}
            checked={!!(deliveryDays?.length && deliveryDays.includes(SHORT_DAYS_MAP[day]))}
            key={day}
            onChange={createDayChangeHandler(SHORT_DAYS_MAP[day])}
          >
            {day}
          </DeliveryCheckbox>
        ))}
      </Flex>
    </>
  );
};

export default DeliveryDaysList;
